import styled from '@emotion/styled';

const IconsWrapper = styled('div')({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
});

export default IconsWrapper;
